<section>
  <img src="assets/img/svg/esmart-logo.svg" alt="EMP Logo" />

  <img src="assets/img/svg/robot-circle.svg" />

  <h3>{{ 'LOGIN__EMAIL_SENT' | translate }}</h3>

  <p>{{ 'LOGIN__CHECK_EMAIL' | translate }}</p>

  <button class="es-btn es-btn-lg es-btn-accented" routerLink="/login">
    {{ 'LOGIN__BACK_TO_LOGIN' | translate | uppercase }}
  </button>
</section>
